import React, { useContext, useEffect, useState } from "react";
import ClientsContext from "../../../Reducers/Clients/ClientsContext";
import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";

const SelectClient = ({
  detectarCambiosClient,
  id_branch_office,
  clientEdit,
}) => {
  const { getclients, clients } = useContext(ClientsContext);
  const [selectedClient, setSelectedClient] = useState("");

  useEffect(() => {
    getclients(id_branch_office);
  }, [id_branch_office]);

  useEffect(() => {
    const defaultClient = clients.find(
      (client) =>
        `${client.name} ${client.first_lastname} ${client.second_lastname}` ===
        clientEdit
    );
    if (defaultClient) {
      setSelectedClient(defaultClient.id);
      detectarCambiosClient(defaultClient.id);
    }
  }, [clientEdit, clients]);

  const handleClientChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedClient(selectedValue);
    detectarCambiosClient(selectedValue);
  };

  return (
    <FormControl fullWidth>
      <InputLabel id="client-select-label">Selecciona un Cliente</InputLabel>
      <Select
        labelId="client-select-label"
        id="client-select"
        value={selectedClient}
        onChange={handleClientChange}
        label="Selecciona un Cliente"
      >
        {clients.map((client) => (
          <MenuItem key={client.id} value={client.id}>
            {`${client.name} ${client.first_lastname} ${client.second_lastname}`}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SelectClient;
